export const ShowNomination = ({ nomination, region, loading }) => {
	const selectedRegion =
		!loading &&
		region &&
		region.filter(function (item) {
			return item.id === nomination[0].region_id;
		});

const data = nomination[0]

	return (
		<>
			{!loading && (
				<>
					<section
						className='profile'
						style={{ maxWidth: '1120px', margin: '0 auto' }}
					>
						<h3
							className='profile__title'
							style={{
								textAlign: 'center',
								padding: '30px 0',
								color: '#00529C',
							}}
						>
							Ваша заявка была принята, большое спасибо за участие !
						</h3>

						<form className='profile-form'>
							<div className='profile-form__block'>
								<h3 className='profile-form__title'>О проекте</h3>

								<div className='profile-form__col profile-form__row_second'>
									<div className='profile-form__row'>
										<div className='profile-form__input'>
											<label className='profile-form__label'>
												Субъект РФ<i>*</i>
											</label>
											<input
												name='region_id'
												id='region_id'
												className='input'
												disabled
												placeholder='Выберите субъект РФ'
												value={selectedRegion[0].name}
											/>
										</div>
										<div className='profile-form__input'>
											<label
												htmlFor='operation_area'
												className='profile-form__label'
											>
												Территория деятельности<i>*</i>
											</label>
											<div className='profile-form__input-wrap'>
												<input
													className='input'
													disabled
													id='operation_area'
													name='operation_area'
													type='text'
													placeholder='Наименование'
													value={data.operation_area || undefined}
												/>
												<span className='profile-form__msg'>
													наименование города, микрорайона и т.п.
												</span>
											</div>
										</div>

										<div className='profile-form__input'>
											<label
												htmlFor='organization_name'
												className='profile-form__label'
											>
												Наименование объединения, НКО, клуба<i>*</i>
											</label>
											<div className='profile-form__input-wrap'>
												<input
													className='input'
													disabled
													id='organization_name'
													name='organization_name'
													type='text'
													placeholder='Наименование'
													value={data.organization_name || undefined}
												/>
											</div>
										</div>
									</div>
									<div className='profile-form__row'>
										<div className='profile-form__input'>
											<label
												htmlFor='operation_period'
												className='profile-form__label'
											>
												Период деятельности<i>*</i>
											</label>
											<div className='profile-form__input-wrap'>
												<input
													disabled
													className='input'
													id='operation_period'
													name='operation_period'
													type='text'
													placeholder='Период деятельности'
													value={data.operation_period || undefined}
												/>
											</div>
										</div>
										<div className='profile-form__input'>
											<label
												htmlFor='operation_direction'
												className='profile-form__label'
											>
												Основные направления работы<i>*</i>
											</label>
											<div className='profile-form__input-wrap'>
												<input
													className='input'
													disabled
													id='operation_direction'
													name='operation_direction'
													type='text'
													placeholder='Основные направления работы'
													value={data.operation_direction || undefined}
												/>
											</div>
										</div>

										<div className='profile-form__input'>
											<label
												htmlFor='members_number'
												className='profile-form__label'
											>
												Количество участников<i>*</i>
											</label>
											<div className='profile-form__input-wrap'>
												<input
													className='input'
													disabled
													id='members_number'
													name='members_number'
													type='text'
													placeholder='Количество участников'
													value={data.members_number || undefined}
												/>
											</div>
										</div>
									</div>
									<div className='profile-form__row profile-form__row-textarea'>
										<div className='profile-form__input'>
											<label
												htmlFor='project_description'
												className='profile-form__label'
											>
												Содержание проведенной работы за последние 2 года
												<i>*</i>
											</label>
											<div className='profile-form__input-wrap'>
												<textarea
													className='input'
													disabled
													id='project_description'
													name='project_description'
													type='text'
													placeholder='Содержание проведенной работы за последние 2 года (описание проведенных мероприятий, охват мероприятий и т.п.)'
													value={data.project_description || undefined}
												/>
												<span className='profile-form__msg'>
													описание проведенных мероприятий, охват мероприятий и
													т.п.
												</span>
											</div>
										</div>
										<div className='profile-form__input'>
											<label
												htmlFor='perspectives'
												className='profile-form__label'
											>
												Перспективы развития организации<i>*</i>
											</label>
											<div className='profile-form__input-wrap'>
												<textarea
													className='input'
													disabled
													id='perspectives'
													name='perspectives'
													type='text'
													placeholder='Перспективы развития организации (планы по проведению мероприятий на ближайший год)'
													value={data.perspectives || undefined}
												/>
												<span className='profile-form__msg'>
													планы по проведению мероприятий на ближайший год
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div className='profile-form__block'>
								<h3 className='profile-form__title'>Материалы</h3>

								<div className='profile-form__row profile-form__row_second'>
									<div
										className='profile-form__input'
										style={{ display: 'flex', flexDirection: 'column' }}
									>
										<label htmlFor='file' className='profile-form__label'>
											Форма заявки<i>*</i>
										</label>
										{nomination[0].application_form?.name}
									</div>

									<div
										className='profile-form__input'
										style={{ display: 'flex', flexDirection: 'column' }}
									>
										<label htmlFor='name' className='profile-form__label'>
											Видео
										</label>
										{nomination[0].videos?.map((e, i) => (
											<span key={i}>{e}</span>
										))}
									</div>

									<div
										className='profile-form__input'
										style={{
											display: 'flex',
											flexDirection: 'column',
											marginBottom: '30px',
										}}
									>
										<label htmlFor='file' className='profile-form__label'>
											Фотографии
										</label>
										{nomination[0].images?.map((e, i) => (
											<span key={i}>{e.name}</span>
										))}
									</div>
								</div>
							</div>
						</form>
					</section>
				</>
			)}
		</>
	);
};
